// extracted by mini-css-extract-plugin
export default {"screen-slider":"screen-slider--uvr9f","screenSlider":"screen-slider--uvr9f","track":"track--GN_5_","slide-frame":"slide-frame--dqaGb","slideFrame":"slide-frame--dqaGb"};